import { Helmet } from "react-helmet";

export type CarData = {
  slug: string;
  title: string;
  brand: string;
  model: string;
  year: number;
  vin?: string;
  price: number;
  currency: string;
  availability: "https://schema.org/InStock" | "https://schema.org/OutOfStock";
  condition: "https://schema.org/NewCondition" | "https://schema.org/UsedCondition";
  mileage: number;
  mileageUnit: "KMT" | "SMI";
  image: string[];
  color?: string;
  bodyType?: string;
  trim?: string;
  fuelType?: string;
  transmission?: string;
  doors?: number;
  seats?: number;
};

export const SeoCarSchema = (car: CarData) => {
  const schema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Car",
    name: car.title,
    brand: {
      "@type": "Brand",
      name: car.brand,
    },
    model: car.model,
    vehicleModelDate: String(car.year),
    itemCondition: car.condition,
    url: `${window.location.origin}/${car.slug}`,
    image: car.image,
    offers: {
      "@type": "Offer",
      price: car.price,
      priceCurrency: car.currency,
      availability: car.availability,
      url: `${window.location.origin}/${car.slug}`,
    },
    mileageFromOdometer: {
      "@type": "QuantitativeValue",
      value: car.mileage,
      unitCode: car.mileageUnit,
    },
  };

  if (car.vin) {
    schema.vehicleIdentificationNumber = car.vin;
  }
  if (car.color) {
    schema.color = car.color;
  }
  if (car.bodyType) {
    schema.bodyType = car.bodyType;
  }
  if (car.trim) {
    schema.vehicleConfiguration = car.trim;
  }
  if (car.fuelType) {
    schema.vehicleEngine = {
      "@type": "EngineSpecification",
      fuelType: car.fuelType,
    };
  }
  if (car.transmission) {
    schema.vehicleTransmission = car.transmission;
  }
  if (car.doors) {
    schema.numberOfDoors = car.doors;
  }
  if (car.seats) {
    schema.vehicleSeatingCapacity = car.seats;
  }

  return (
    <Helmet encodeSpecialCharacters={false}>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
